import type { EventEmitterUtil } from '@chesscom/web-ui';

export namespace Logger {
  export interface API extends EventEmitterUtil.EventEmitter {
    clear(): void;
    get(filterByProps?: Partial<Logger.Entry>): Logger.Entry[];
    log(params: EntryParams): void;
    setLogLevel(newLevel: Logger.Levels): void;
  }

  export interface Entry {
    code: string;
    data: any;
    level: Levels;
    message?: string;
    timestamp: number;
  }

  export interface EntryParams {
    code: string;
    data: any;
    level?: Levels;
    message?: string;
  }

  export enum Events {
    EntryAdded = 'EntryAdded',
  }

  export enum Levels {
    Debug = 'Debug',
    Error = 'Error',
    None = 'None',
  }
}
